import clsx from 'clsx';
import { sanitize } from '@americanexpress/consumer-travel-base';
import { MarketingTilesArticlesProps } from '../../types/components';
import { GUEST } from '../../constants/cardTypeConstants';
import { MarketingTilesCard } from './MarketingTilesCard';
import RenderEarlyTenureOrHomeTopColumnTile from '../RenderEarlyTenureOrHomeTopColumnTile/RenderEarlyTenureOrHomeTopColumnTile';
import styles from './MarketingTiles.scss';

const COLUMN_CLASS_NAMES = 'col-12 col-md-6 col-lg-3';

export const MarketingTilesArticles = ({
  heading,
  cards,
  cardType = GUEST,
}: MarketingTilesArticlesProps) => {
  const hasArticles = Array.isArray(cards) && cards.length > 0;
  const hasValidArticles = hasArticles && cards.every((cards) => cards?.heading && cards?.subHeading);

  if (!hasValidArticles) {
    return null;
  }

  const [firstCard, ...restCards] = cards;

  return (
    <div
      data-testid="personalized-marketing-articles"
    >
      {heading && (
      <h2
        className="heading-sans-large-book pad-3-b pad-2-b-md-down pad-1-b-sm-down pad-1-l-md-down"
        dangerouslySetInnerHTML={{ __html: sanitize(heading) }}
      />
      )}
      <div
        id="personalised-marketing-row"
        className="row pad-lr-lg-down flex-justify-center"
      >
        <RenderEarlyTenureOrHomeTopColumnTile
          cardType={cardType}
          className={clsx('margin-2-b', COLUMN_CLASS_NAMES, styles.marketingTilesWelcomeCardWrapper)}
          component={MarketingTilesCard}
          travelHomeTopColumnTileContent={firstCard}
        />
        {restCards.map((card, index) => (
          <MarketingTilesCard
            key={`${card?.heading.toLowerCase().replace(/\s/g, '-')}-${index}`}
            className={COLUMN_CLASS_NAMES}
            content={card}
            index={index + 2}
          />
        ))}
      </div>
    </div>
  );
};
